import APIPolicies from "@/mixins/APIPolicies";
import moment from "vue-moment";
import Domain from "./domain";
export default {
  mixins: [APIPolicies],
  data() {
    return {
      policies: [],
      wwcc_status: [
        {
          text: "No",
          value: 0
        },
        {
          text: "Yes, not with me",
          value: 1
        },
        {
          text: "Yes",
          value: 2
        }
      ]
    };
  },
  computed: {
    baseURL: function() {
      return Domain.BASE_DOMAIN;
    },
    toDay: function() {
      const moment = require("moment");
      let now = moment();
      let date = now.format();
      let fomatDate = date.split("T");
      return fomatDate[0];
    },
    permissions: function() {
      let modules = [];
      if (localStorage.active_user) {
        let object = JSON.parse(localStorage.active_user);
        modules = object.permissions || object.modules || [];
      }
      return modules;
    },
    user: function() {
      if (localStorage.active_user) {
        let object = JSON.parse(localStorage.active_user);
        if (object.company_user) {
          let obj = Object.assign({}, object.company_user);
          delete obj.token;
          delete obj.success;
          delete obj.created_date;
          delete obj.alrady_loged;
          return obj;
        }
        delete object.token;
        delete object.success;
        delete object.created_date;
        delete object.alrady_loged;
        return object;
      }
      return {};
    }
  },
  methods: {
    refreshPoliciesList: async function() {
      try {
        this.policies = await this.getPolicies();
      } catch (error) {
        this.$toast.error("Cannot get details!", "Error", {
          position: "topCenter"
        });
      }
    },
    formattedImage: function(image, placeholder) {
      if (image && image.includes("base64")) {
        return image;
      } else if (image && image.includes(placeholder)) {
        return placeholder;
      } else if (image && image.includes(this.baseURL)) {
        return image;
      } else if (image) {
        return this.baseURL + image;
      } else {
        return placeholder;
      }
    },
    permitted: function(prob) {
      return this.permissions.includes(prob);
    },
    isRole: function(role) {
      if (!localStorage.active_user) return false;
      let object = JSON.parse(localStorage.active_user);
      return object.role == role;
    },
    wwccStatus: function(wwcc_card) {
      wwcc_card = String(wwcc_card);
      if (wwcc_card === "1") {
        return "Yes, not with me";
      } else if (wwcc_card === "2") {
        return "Yes";
      } else if (wwcc_card === "3") {
        return "Yes";
      } else {
        return "No";
      }
    },
    formatDate: function(date) {
      return moment(date).format("dddd MMM DD");
    },
    titleCase: function(str) {
      str = str.toLowerCase().split(" ");
      for (var i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      return str.join(" ");
    },
    plural: function(ety) {
      if (ety.toLowerCase() === "staff") {
        return ety;
      }
      return ety + "s";
    }
  }
};
